module.exports = "/assets/d6848183407bf037714bd7c23f73a5a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/obb.svg
// module id = 3595
// module chunks = 0